
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Search, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Myevents.css';
import coldImg from '../assets/images/cold.png';
import arrowImg from '../assets/images/arrow.png';
import Upcommingexprences from '../components/Upcommingexprences';
import doubleleftarrow from '../assets/images/doubleleftarrow.png';
import leftarrow from '../assets/images/leftarrow.png';
import rightarrow from '../assets/images/rightarrow.png';
import doublerightarrow from '../assets/images/doublerightarrow.png';
import attendedBadge from '../assets/images/attended.png';
import absentBadge from '../assets/images/absent.png';
import upcomingBadge from '../assets/images/upcoming.png';
import failed from "../assets/images/failed.png";

const Myevents = () => {
    const navigate = useNavigate();
    const PAGE_SIZE = 6;
    const [searchText, setSearchText] = useState('');
    const [selectedcity, setSelectedcity] = useState('All');
    const [selectedType, setSelectedType] = useState('All');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [iscityOpen, setIscityOpen] = useState(false);
    const [isTypeOpen, setIsTypeOpen] = useState(false);
    const [isStatusOpen, setIsStatusOpen] = useState(false);
    const [isDateOpen, setIsDateOpen] = useState(false);
    const [range, setRange] = useState({ start: null, end: null });
    const [displayMonth, setDisplayMonth] = useState(new Date());
    const cityDropdownRef = useRef(null);
    const dateDropdownRef = useRef(null);
    const typeDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);

    const [events, setEvents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const cityOptions = useMemo(() => {
        const values = new Set();
        events.forEach((event) => {
            if (event.city) {
                values.add(event.city);
            }
        });
        return ['All', ...Array.from(values)];
    }, [events]);

    const nameOptions = useMemo(() => {
        const values = new Set();
        events.forEach((event) => {
            if (event.title) {
                values.add(event.title);
            }
        });
        return ['All', ...Array.from(values)];
    }, [events]);

    const statuses = ['All', 'Upcoming', "Today", 'Completed'];

    const limitWords = (value, maxWords) => {
        if (!value) return '';
        const words = value.trim().split(/\s+/);
        if (words.length <= maxWords) return value;
        return `${words.slice(0, maxWords).join(' ')}...`;
    };

    const makeEvent = (dateIso, title, city, type, status, overrides = {}) => {
        const eventDate = new Date(dateIso);
        return {
            id: overrides.id || null,
            dateIso,
            dateDay: `${eventDate.getDate()}`,
            dateMonth: eventDate.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
            title,
            city,
            type,
            status,
            time: overrides.time || "05:00 PM Onwards",
            description: overrides.description || "A thoughtfully designed singles mixer where conversations flow naturally - without pressure, expectations, or forced interactions.",
            imageUrl: overrides.imageUrl || coldImg,
            orderStatus: overrides.orderStatus || null
        };
    };

    const resolveStatus = (dateIso) => {
        const eventDate = new Date(dateIso);
        if (Number.isNaN(eventDate.getTime())) {
            return 'Upcoming';
        }
        const today = new Date();
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const eventStart = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
        if (eventStart.getTime() === todayStart.getTime()) {
            return 'Today';
        }
        return eventStart < todayStart ? 'Completed' : 'Upcoming';
    };

    useEffect(() => {
        let isMounted = true;
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

        const loadEvents = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE_URL}/api/v1/orders/my-orders?page=1&limit=10`, {
                    headers: {
                        authorization: token ? `Bearer ${token}` : ''
                    }
                });
                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to load events');
                }

                const items = Array.isArray(data.orders) ? data.orders : [];
                const mapped = items.map((item) => {
                    const details = item.eventDetails || {};
                    const cityLabel = details.city
                        || [details.city, details.state, details.country].filter(Boolean).join(', ')
                        || 'city TBA';
                    const rawThumbnail = details.thumbnail || '';
                    const normalizedThumbnail = rawThumbnail
                        ? rawThumbnail.replace(/^https?:\/\/localhost(:\d+)?/i, API_BASE_URL)
                        : '';
                    const statusFromDate = resolveStatus(details.date);
                    return makeEvent(details.date, details.title || 'EVENT', cityLabel, details.type || 'All', statusFromDate, {
                        id: details._id || item.eventId || item._id,
                        orderId: item._id || item.orderId || item.order_id || item.eventId,
                        order: item,
                        time: details.time || undefined,
                        description: details.shortDescription || details.description,
                        imageUrl: normalizedThumbnail || rawThumbnail,
                        orderStatus: item.status || null
                    });
                });

                if (isMounted) {
                    setEvents(mapped);
                }
            } catch (error) {
                console.error('Failed to load events', error);
            }
        };

        loadEvents();

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (!iscityOpen && !isDateOpen && !isTypeOpen && !isStatusOpen) {
            return undefined;
        }

        const handleOutsideClick = (event) => {
            const target = event.target;
            const isInsidecity = cityDropdownRef.current && cityDropdownRef.current.contains(target);
            const isInsideDate = dateDropdownRef.current && dateDropdownRef.current.contains(target);
            const isInsideType = typeDropdownRef.current && typeDropdownRef.current.contains(target);
            const isInsideStatus = statusDropdownRef.current && statusDropdownRef.current.contains(target);

            if (!isInsidecity && !isInsideDate && !isInsideType && !isInsideStatus) {
                setIscityOpen(false);
                setIsDateOpen(false);
                setIsTypeOpen(false);
                setIsStatusOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [iscityOpen, isDateOpen, isTypeOpen, isStatusOpen]);

    const formatReadableDate = (date) => {
        if (!date) return '';
        return date.toLocaleString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatRangeLabel = () => {
        if (!range.start) return 'Select date range';
        if (range.start && !range.end) return formatReadableDate(range.start);
        return `${formatReadableDate(range.start)} - ${formatReadableDate(range.end)}`;
    };

    const handleDateSelect = (selectedDate) => {
        if (!range.start || (range.start && range.end)) {
            setRange({ start: selectedDate, end: null });
            return;
        }
        if (selectedDate < range.start) {
            setRange({ start: selectedDate, end: range.start });
            return;
        }
        setRange({ start: range.start, end: selectedDate });
    };

    const getMonthMatrix = (year, month) => {
        const firstDay = new Date(year, month, 1);
        const startDay = firstDay.getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const cells = [];

        for (let i = 0; i < startDay; i += 1) {
            cells.push(null);
        }
        for (let day = 1; day <= daysInMonth; day += 1) {
            cells.push(new Date(year, month, day));
        }
        return cells;
    };

    const applyPreset = (preset) => {
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

        if (preset === 'Today') {
            setRange({ start: today, end: today });
        } else if (preset === 'Yesterday') {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            setRange({ start: yesterday, end: yesterday });
        } else if (preset === 'Last 7 days') {
            const start = new Date(today);
            start.setDate(today.getDate() - 6);
            setRange({ start, end: today });
        } else if (preset === 'Last 30 days') {
            const start = new Date(today);
            start.setDate(today.getDate() - 29);
            setRange({ start, end: today });
        } else if (preset === 'This month') {
            setRange({ start: startOfMonth, end: endOfMonth });
        } else if (preset === 'Last month') {
            setRange({ start: lastMonthStart, end: lastMonthEnd });
        } else {
            setRange({ start: null, end: null });
        }
    };

    const filteredEvents = events.filter((event) => {
        const searchValue = searchText.trim().toLowerCase();
        const matchesSearch = !searchValue
            || event.title.replace(/\s+/g, ' ').toLowerCase().includes(searchValue)
            || event.city.toLowerCase().includes(searchValue);
        const matchescity = selectedcity === 'All' || event.city === selectedcity;
        const matchesType = selectedType === 'All' || event.title === selectedType;
        const matchesStatus = selectedStatus === 'All' || event.status === selectedStatus;

        if (!range.start || !range.end) {
            return matchesSearch && matchescity && matchesType && matchesStatus;
        }

        const eventDate = new Date(event.dateIso);
        const start = new Date(range.start.getFullYear(), range.start.getMonth(), range.start.getDate());
        const end = new Date(range.end.getFullYear(), range.end.getMonth(), range.end.getDate());
        const matchesDate = eventDate >= start && eventDate <= end;

        return matchesSearch && matchescity && matchesType && matchesStatus && matchesDate;
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [searchText, selectedcity, selectedType, selectedStatus, range.start, range.end]);

    const totalPages = Math.max(1, Math.ceil(filteredEvents.length / PAGE_SIZE));
    const safePage = Math.min(currentPage, totalPages);
    const pageStart = (safePage - 1) * PAGE_SIZE;
    const pagedEvents = filteredEvents.slice(pageStart, pageStart + PAGE_SIZE);

    const getPageItems = () => {
        if (totalPages <= 5) {
            return Array.from({ length: totalPages }, (_, idx) => idx + 1);
        }
        const pages = new Set([1, totalPages, safePage - 1, safePage, safePage + 1]);
        return Array.from(pages)
            .filter((page) => page >= 1 && page <= totalPages)
            .sort((a, b) => a - b);
    };

    const pageItems = getPageItems();

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthA = new Date(displayMonth.getFullYear(), displayMonth.getMonth(), 1);
    const monthB = new Date(displayMonth.getFullYear(), displayMonth.getMonth() + 1, 1);
    const monthACells = getMonthMatrix(monthA.getFullYear(), monthA.getMonth());
    const monthBCells = getMonthMatrix(monthB.getFullYear(), monthB.getMonth());

    return (
        <>
            <div className="esm-upcome-container">
                {/* Header Section */}
                <div className="esm-header-section">
                    <div className="esm-upcoming-badge">My Experiences</div>
                    <div className="esm-header-description">
                        A place to keep track of the experiences you’ve been part of — and what’s coming next.
                    </div>
                </div>

                {/* Filter Section */}
                <div className="esm-filter-wrapper">
                    <div className="esm-filter-box" style={{ maxWidth: '280px' }}>
                        <input
                            type="text"
                            className="esm-filter-input"
                            placeholder="Search experiences"
                            value={searchText}
                            onChange={(event) => setSearchText(event.target.value)}
                        />
                        <Search className="esm-filter-icon" size={20} />
                    </div>

                    <div className="esm-filter-box" style={{ maxWidth: '180px' }} ref={cityDropdownRef}>
                        <button
                            type="button"
                            className="esm-filter-dropdown"
                            onClick={() => {
                                setIscityOpen((prev) => !prev);
                                setIsTypeOpen(false);
                                setIsDateOpen(false);
                                setIsStatusOpen(false);
                            }}
                        >
                            <span>{selectedcity === 'All' ? 'Search city' : selectedcity}</span>
                            <ChevronDown size={20} />
                        </button>
                        {iscityOpen && (
                            <div className="esm-filter-menu">
                                {cityOptions.map((city) => (
                                    <button
                                        key={city}
                                        type="button"
                                        className={`esm-filter-option${selectedcity === city ? ' esm-filter-option-active' : ''}`}
                                        onClick={() => {
                                            setSelectedcity(city);
                                            setIscityOpen(false);
                                        }}
                                    >
                                        {city}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="esm-filter-box" style={{ maxWidth: '240px' }} ref={dateDropdownRef}>
                        <button
                            type="button"
                            className="esm-filter-dropdown"
                            onClick={() => {
                                setIsDateOpen((prev) => !prev);
                                setIscityOpen(false);
                                setIsTypeOpen(false);
                                setIsStatusOpen(false);
                            }}
                        >
                            <span>{formatRangeLabel()}</span>
                            <ChevronDown size={20} />
                        </button>
                        {isDateOpen && (
                            <div className="esm-date-picker">
                                <div className="esm-date-sidebar">
                                    <div className="esm-date-sidebar-title">Recently used</div>
                                    {['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'This month', 'Last month', 'Custom'].map((preset) => (
                                        <button
                                            key={preset}
                                            type="button"
                                            className="esm-date-preset"
                                            onClick={() => applyPreset(preset)}
                                        >
                                            {preset}
                                        </button>
                                    ))}
                                </div>

                                <div className="esm-date-main">
                                    <div className="esm-date-header">
                                        <button
                                            type="button"
                                            className="esm-date-nav"
                                            onClick={() => setDisplayMonth(new Date(displayMonth.getFullYear(), displayMonth.getMonth() - 1, 1))}
                                        >
                                            &#8249;
                                        </button>
                                        <div className="esm-date-months">
                                            <div className="esm-date-month-label">{monthNames[monthA.getMonth()]} {monthA.getFullYear()}</div>
                                            <div className="esm-date-month-label">{monthNames[monthB.getMonth()]} {monthB.getFullYear()}</div>
                                        </div>
                                        <button
                                            type="button"
                                            className="esm-date-nav"
                                            onClick={() => setDisplayMonth(new Date(displayMonth.getFullYear(), displayMonth.getMonth() + 1, 1))}
                                        >
                                            &#8250;
                                        </button>
                                    </div>

                                    <div className="esm-date-calendars">
                                        {[{ month: monthA, cells: monthACells }, { month: monthB, cells: monthBCells }].map((monthData) => (
                                            <div key={monthData.month.toISOString()} className="esm-calendar">
                                                <div className="esm-calendar-weekdays">
                                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                                        <span key={day}>{day}</span>
                                                    ))}
                                                </div>
                                                <div className="esm-calendar-grid">
                                                    {monthData.cells.map((date, index) => {
                                                        if (!date) {
                                                            return <span key={`${monthData.month.toISOString()}-empty-${index}`} className="esm-calendar-empty" />;
                                                        }
                                                        const isStart = range.start && date.toDateString() === range.start.toDateString();
                                                        const isEnd = range.end && date.toDateString() === range.end.toDateString();
                                                        const isBetween = range.start && range.end && date > range.start && date < range.end;
                                                        return (
                                                            <button
                                                                key={date.toISOString()}
                                                                type="button"
                                                                className={`esm-calendar-day${isStart || isEnd ? ' esm-calendar-day-active' : ''}${isBetween ? ' esm-calendar-day-range' : ''}`}
                                                                onClick={() => handleDateSelect(date)}
                                                            >
                                                                {date.getDate()}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="esm-date-footer">
                                        {/* <div className="esm-date-fields">
                                            <select className="esm-date-custom">
                                                <option>Custom</option>
                                            </select>
                                            <input
                                                type="text"
                                                readOnly
                                                className="esm-date-input"
                                                value={range.start ? formatReadableDate(range.start) : ''}
                                                placeholder="Start date"
                                            />
                                            <input
                                                type="text"
                                                readOnly
                                                className="esm-date-input"
                                                value={range.end ? formatReadableDate(range.end) : ''}
                                                placeholder="End date"
                                            />
                                        </div> */}
                                        <div className="esm-date-actions">
                                            <button
                                                type="button"
                                                className="esm-date-cancel"
                                                onClick={() => {
                                                    setRange({ start: null, end: null });
                                                    setIsDateOpen(false);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="esm-date-apply"
                                                onClick={() => setIsDateOpen(false)}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="esm-filter-box" style={{ maxWidth: '200px' }} ref={typeDropdownRef}>
                        <button
                            type="button"
                            className="esm-filter-dropdown"
                            onClick={() => {
                                setIsTypeOpen((prev) => !prev);
                                setIscityOpen(false);
                                setIsDateOpen(false);
                                setIsStatusOpen(false);
                            }}
                        >
                            <span>{selectedType === 'All' ? 'Events name ' : selectedType}</span>
                            <ChevronDown size={20} />
                        </button>
                        {isTypeOpen && (
                            <div className="esm-filter-menu">
                                {nameOptions.map((type) => (
                                    <button
                                        key={type}
                                        type="button"
                                        className={`esm-filter-option${selectedType === type ? ' esm-filter-option-active' : ''}`}
                                        onClick={() => {
                                            setSelectedType(type);
                                            setIsTypeOpen(false);
                                        }}
                                    >
                                        {type}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="esm-filter-box" style={{ maxWidth: '200px' }} ref={statusDropdownRef}>
                        <button
                            type="button"
                            className="esm-filter-dropdown"
                            onClick={() => {
                                setIsStatusOpen((prev) => !prev);
                                setIscityOpen(false);
                                setIsDateOpen(false);
                                setIsTypeOpen(false);
                            }}
                        >
                            <span>{selectedStatus === 'All' ? 'Status' : selectedStatus}</span>
                            <ChevronDown size={20} />
                        </button>
                        {isStatusOpen && (
                            <div className="esm-filter-menu">
                                {statuses.map((status) => (
                                    <button
                                        key={status}
                                        type="button"
                                        className={`esm-filter-option${selectedStatus === status ? ' esm-filter-option-active' : ''}`}
                                        onClick={() => {
                                            setSelectedStatus(status);
                                            setIsStatusOpen(false);
                                        }}
                                    >
                                        {status}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Events Grid */}
                {filteredEvents.length === 0 ? (
                    <div className="esm-empty-state">
                        <div className="esm-empty-title">Book your event first</div>
                        <div className="esm-empty-subtitle">
                            You have no experiences yet. Start exploring and book your first event.
                        </div>
                        <button
                            type="button"
                            className="esm-empty-btn"
                            onClick={() => navigate('/events')}
                        >
                            Browse Events
                        </button>
                    </div>
                ) : (
                    <div className="esm-events-gridd">
                        {pagedEvents.map((event, index) => {
                            const eventDate = new Date(event.dateIso);
                            const today = new Date();
                            const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                            const eventStart = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
                            const isPastEvent = eventStart < todayStart;
                            let badgeSrc = null;
                            let badgeAlt = '';
                            if (event.orderStatus === 'attended') {
                                badgeSrc = attendedBadge;
                                badgeAlt = 'Attended';
                            } else if (event.orderStatus === 'paid' && isPastEvent) {
                                badgeSrc = absentBadge;
                                badgeAlt = 'Absent';
                            }else if (event.orderStatus === 'failed'){
                                badgeSrc = failed;
                                badgeAlt = 'Payment Failed';
                            }
                                else if (!isPastEvent) {
                                badgeSrc = upcomingBadge;
                                badgeAlt = 'Upcoming';
                            }
                            return (
                            <div 
                                key={index} 
                                className="esm-event-cart"
                                onClick={() => navigate(event.orderId ? `/Finalticket/${event.orderId}` : '/Finalticket', {
                                    state: {
                                        orderId: event.orderId || event.id,
                                        order: event.order
                                    }
                                })}
                                style={{ cursor: 'pointer' }}
                            >
                                {badgeSrc && (
                                    <img src={badgeSrc} alt={badgeAlt} className="esm-status-badge" />
                                )}
                                <div className="esm-card-header">
                                    <div style={{ textAlign: "center" }}>
                                        <div className="esm-date-container">
                                            <span className="esm-date-day">{event.dateDay}</span>
                                            <span className="esm-date-month">{event.dateMonth}</span>
                                        </div>
                                        <h3 className="esm-card-tit">{event.title}</h3>
                                    </div>
                                    <div className="esm-card-image-wrapper">
                                        <img src={event.imageUrl} alt="Event" className="esm-card-imag" />
                                    </div>
                                </div>
                                <div className="esm-meta-tag">
                                    <span style={{ fontWeight: 600 }}>
                                        {limitWords(event.city, 3)}
                                    </span> | {event.time}
                                </div>
                                <p className="esm-event-desc">{event.description}</p>

                                <div className="esm-arrow-icon">
                                    <img src={arrowImg} alt="" className="esm-arrow-image" />
                                </div>
                            </div>
                        )})}
                    </div>
                )}

                {/* Pagination Section */}
                {filteredEvents.length > 0 && totalPages > 1 && (
                    <div className="esm-pagination-wrapper">
                        <div className="esm-pagination-container">
                            <button
                                className="esm-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage(1)}
                                disabled={safePage === 1}
                            >
                                <img src={doubleleftarrow} alt="Double Left Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <button
                                className="esm-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                                disabled={safePage === 1}
                            >
                                <img src={leftarrow} alt="Left Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <div className="esm-pagination-list">
                                {pageItems.map((page, idx) => {
                                    const prev = pageItems[idx - 1];
                                    const showDots = prev && page - prev > 1;
                                    return (
                                        <React.Fragment key={page}>
                                            {showDots && <span className="esm-pagination-dots">...</span>}
                                            <button
                                                type="button"
                                                className={`esm-pagination-item${page === safePage ? ' esm-pagination-item-active' : ''}`}
                                                onClick={() => setCurrentPage(page)}
                                            >
                                                {page}
                                            </button>
                                        </React.Fragment>
                                    );
                                })}
                            </div>

                            <button
                                className="esm-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                                disabled={safePage === totalPages}
                            >
                                <img src={rightarrow} alt="Right Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>

                            <button
                                className="esm-pagination-arrow"
                                type="button"
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={safePage === totalPages}
                            >
                                <img src={doublerightarrow} alt="Double Right Arrow" style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>
                    </div>
                )}

            </div>

            <Upcommingexprences />
            
        </>
    );
};

export default Myevents;
